
import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MdDashboard, MdOutlineInventory, MdSmartToy } from "react-icons/md";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import { PiStudentBold } from "react-icons/pi";
import { PiChalkboardTeacherFill } from "react-icons/pi";
import { BsCashCoin } from "react-icons/bs";
import { HiOutlineLibrary } from "react-icons/hi";
import { PiExam } from "react-icons/pi";
import { FaBusAlt, FaLock } from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { MdOutlineAddHomeWork } from "react-icons/md";
import { FaRegCalendarTimes } from "react-icons/fa";
import { PiChalkboardTeacher } from "react-icons/pi";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { LuBaggageClaim } from "react-icons/lu";
import { FaPeopleGroup } from "react-icons/fa6";
import { RiNewspaperLine } from "react-icons/ri";
import { ImOffice } from "react-icons/im";
import { GiTeacher } from "react-icons/gi";


function Sidebar({ state, setState }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedSection, setExpandedSection] = useState(null);
  const sidebarHoverBg = "rgba(128, 128, 128, 0.18)";
  const sidebarActiveBg = "rgba(25, 118, 210, 0.18)";
  const sidebarActiveHoverBg = "rgba(25, 118, 210, 0.28)";

  
  const [userRole, setUserRole] = useState("guest");
  const [accessibleModules, setAccessibleModules] = useState(null);

  useEffect(() => {
    const storedUserRole = sessionStorage.getItem("userRole");
    if (storedUserRole) {
      setUserRole(String(storedUserRole).toLowerCase());
    }
    const storedModules = sessionStorage.getItem("accessible_modules");
    if (storedModules) {
      try {
        setAccessibleModules(JSON.parse(storedModules));
      } catch(e) {
        setAccessibleModules([]);
      }
    }
  }, []);

  const hasAccess = (moduleCode) => {
    if (!moduleCode) return true;
    if (!accessibleModules || accessibleModules.length === 0) return true;
    return accessibleModules.includes(moduleCode);
  };


  const handleToggle = (section) => () => {
    setExpandedSection((prev) => (prev === section ? null : section));
  };


  const handleNavigation = (path) => () => {
    navigate(path);
    setState((prevState) => ({ ...prevState, left: false }));
  };

  const createExpandableSection = (sectionName, sectionIcon, items) => {
    if (!items || items.length === 0) return null;
    return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          sx={{
            minHeight: 48,
            px: 2.5,
            "&:hover": {
              backgroundColor: sidebarHoverBg,
            },
          }}
          onClick={handleToggle(sectionName)}
        >
          <ListItemIcon sx={{ minWidth: 30, justifyContent: "center" }}>
            {sectionIcon}
          </ListItemIcon>
          <ListItemText primary={sectionName} />
        </ListItemButton>
      </ListItem>

      {expandedSection === sectionName &&
        items.map((item, index) => {
          const isActive = location.pathname === item.path;

          return (
            <ListItem key={index} disablePadding>
              <ListItemButton
                sx={{
                  minHeight: 40,
                  px: 2,
                  pl: 6,
                  backgroundColor: isActive ? sidebarActiveBg : "transparent",
                  color: isActive ? "black" : "inherit",
                  "&:hover": {
                    backgroundColor: isActive
                      ? sidebarActiveHoverBg
                      : sidebarHoverBg,
                  },
                }}
                onClick={handleNavigation(item.path)}
              >
                {item.icon && (
                  <ListItemIcon sx={{ minWidth: 30, justifyContent: "center" }}>
                    {item.icon}
                  </ListItemIcon>
                )}
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
    </>
  );
  };


  const sidebarWidth = 220;

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : sidebarWidth,
      }}
      role="presentation"
    >
      <List>
        {userRole === "admin" && (
          <>
            {createExpandableSection("Dashboard", <MdDashboard />, [
              { path: "/admin/overall-dashboard", text: "Overall", code: "dashboard.fee_dashboard" },
              { path: "/admin/school-dashboard", text: "School Dashboard", code: "dashboard.fee_dashboard" },
              { path: "/admin/fee-dashboard", text: "Fee", code: "dashboard.fee_dashboard" },
              { path: "/admin/student-attendance-list", text: "Attendance", code: "dashboard.attendance" },
              { path: "/admin/trustee-dashboard", text: "Trustee Dashboard", code: "dashboard.trustee_dashboard" },
              { path: "/admin/principal-dashboard", text: "Principal Dashboard", code: "dashboard.principal_dashboard" },
              { path: "/admin/superadmin-dashboard", text: "Super Admin Dashboard", code: "dashboard.superadmin_dashboard" },
              { path: "/admin/Register-dashboard", text: "Register Dashboard", code: "dashboard.Register_dashboard" },
              { path: "/admin/accountant-dashboard", text: "Accountant Dashboard", code: "dashboard.accountant_dashboard" },
              { path: "/admin/hr-dashboard", text: "HR Dashboard", code: "dashboard.hr_dashboard" },
              { path: "/admin/exam-dashboard", text: "Exam Dashboard", code: "dashboard.exam_dashboard" },
              { path: "/admin/teacher-dashboard", text: "Teacher Dashboard", code: "dashboard.teacher_dashboard" },
              { path: "/admin/student-dashboard", text: "Student Dashboard", code: "dashboard.student_dashboard" },
              { path: "/admin/parent-dashboard", text: "Parent Dashboard", code: "dashboard.parent_dashboard" },
              { path: "/admin/tp-dashboard", text: "Training & Placement Dashboard", code: "dashboard.tp_dashboard" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Student", <PiStudentBold />, [
              { path: "/admin/registration", text: "Registration", code: "student.registration" },
              { path: "/admin/Attendance-update", text: "Attendance", code: "student.attendance" },
              { path: "/admin/assignment-entry", text: "Assignment", code: "student.assignment" },
              { path: "/admin/student-promotion", text: "Promotion", code: "student.promotion" },
              { path: "/admin/student-class", text: "Student Class", code: "student.class" },
              { path: "/admin/student-confirm", text: "Student Confirm", code: "student.confirm" },
              { path: "/admin/student-certificate", text: "Student Certificate", code: "student.certificate" },
              { path: "/admin/student-message", text: "Student Message", code: "student.message" },
              { path: "/admin/student-club", text: "Student Club", code: "student.club" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Others", <PersonAddOutlinedIcon />, [
              { path: "/admin/circular-entry", text: "Circulars", code: "student.circular" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Staff", <PiChalkboardTeacherFill />, [
              { path: "/admin/employee-search", text: "Registration", code: "staff.registration" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Fee", <BsCashCoin />, [
              { path: "/admin/fee-search", text: "Search", code: "fee.search" },
              { path: "/admin/adhoc-fees", text: "ADHOC Fees", code: "fee.adhoc" },
              { path: "/admin/fee-ledger", text: "Fee Ledger", code: "fee.ledger" },
              { path: "/admin/student-fee", text: "Student Fee", code: "fee.student_fee" },
              { path: "/admin/fee-structure", text: "Fee Structure", code: "fee.structure" },
              { path: "/admin/fee-report", text: "Fee Report", code: "fee.report" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Library", <HiOutlineLibrary />, [
              { path: "/admin/library-dashboard", text: "Library Dashboard", code: "library.library_dashboard" },
              { path: "/admin/book-dashboard", text: "Book Dashboard", code: "library.dashboard" },
              { path: "/admin/book-category", text: "Book Category", code: "library.category" },
              { path: "/admin/book-search", text: "Search", code: "library.search" },
              { path: "/admin/book-Configurations", text: "Book Configurations", code: "library.configurations" },
              { path: "/admin/book-movements", text: "Issue/Return", code: "library.movements" },
              { path: "/admin/book-barcode", text: "Book Barcode", code: "library.barcode" },
              { path: "/admin/book-title-report", text: "Book Title Report", code: "library.title_report" },
              { path: "/admin/book-journal-report", text: "Journal Report", code: "library.journal_report" },
              { path: "/admin/book-accession-report", text: "Book Accession Report", code: "library.accession_report" },
              { path: "/admin/book-issue-return-report", text: "Issue/Return Report", code: "library.issue_return_report" },
              { path: "/admin/book-issue-damaged-report", text: "Lost/Damaged Report", code: "library.damaged_report" },
              { path: "/admin/book-most-circulated", text: "Most Circulated Book Report", code: "library.most_circulated" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Exam Results", <PiExam />, [
              { path: "/admin/result", text: "Result", code: "exam_results.result" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Transport", <FaBusAlt />, [
              { path: "/admin/transport-dashboard", text: "Transport Dashboard", code: "transport.dashboard" },
              { path: "/admin/transport-search", text: "Search", code: "transport.search" },
              { path: "/admin/student-transport-fee", text: "Student Transport", code: "transport.student_fee" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Expense", <FaMoneyBillTransfer />, [
              { path: "/admin/search-expense", text: "Search Expense", code: "expense.search" },
              { path: "/admin/expense-category", text: "Expense/Income Category", code: "expense.category" },
              { path: "/admin/party-master", text: "Party Master", code: "expense.party_master" },
              { path: "/admin/expense-ledger", text: "Expense Ledger", code: "expense.ledger" },
              { path: "/admin/profit-loss", text: "Profit & Loss", code: "expense.profit_loss" },
              { path: "/admin/day-book", text: "Day Book", code: "expense.day_book" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Other Income", <GiMoneyStack />, [
              { path: "/admin/Search-income", text: "Search Income", code: "other_income.search" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Hostel", <MdOutlineAddHomeWork />, [
              { path: "/admin/hostel-dashboard", text: "Hostel Dashboard", code: "hostel.dashboard" },
              { path: "/admin/search-hostel", text: "Search", code: "hostel.search" },
              { path: "/admin/student-hostel-details", text: "Student Hostel Details", code: "hostel.student_details" },
              { path: "/admin/student-hostel-fee", text: "Student Hostel Fee", code: "hostel.student_fee" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("TimeTable", <FaRegCalendarTimes />, [
              { path: "/admin/class-time-table", text: "Class TimeTable", code: "timetable.class" },
              { path: "/admin/teacher-time-table", text: "Teacher TimeTable", code: "timetable.teacher" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Lesson Plans", <MdDashboard />, [
              /* { path: "/admin/lesson-plan", text: "Lesson Plan", code: "lessonplan.lesson_plan" }, */
              { path: "/admin/lesson-plan-list", text: "View All Lesson Plans", code: "lessonplan.lesson_plan" },
              { path: "/admin/teacher-lesson-plan", text: "Teacher Lesson Plan", code: "lessonplan.teacher" },
              { path: "/admin/lesson-plan-completion-report", text: "Lesson Plan Completion Report", code: "lessonplan.completion_report" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Mentor", <PiChalkboardTeacher />, [
              { path: "/admin/assign-mentor", text: "Assign Mentor", code: "mentor.assign" },
              { path: "/admin/follows-ups", text: "Follow Ups", code: "mentor.follow_ups" },
              { path: "/admin/student-details", text: "Student Details", code: "mentor.student_details" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Academics", <HiOutlineAcademicCap />, [
              { path: "/admin/document-upload", text: "Document Upload", code: "academics.document_upload" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Grievance", <LuBaggageClaim />, [
              { path: "/admin/student-grievance", text: "Student Grievances", code: "grievance.student" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Visitors", <FaPeopleGroup />, [
              { path: "/admin/visitors-list", text: "Visitors List", code: "visitors.list" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("MOU", <RiNewspaperLine />, [
              { path: "/admin/mou-list", text: "Mou List", code: "mou.list" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Inventory Management", <MdOutlineInventory />, [
              { path: "/admin/inventory-category", text: "Inventory Category", code: "inventory.category" },
              { path: "/admin/inventory-search", text: "Inventory Search", code: "inventory.search" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Assistant", <MdSmartToy />, [
              { path: "/admin/chatbot", text: "AI Chatbot" },
            ].filter(i => hasAccess(i.code)))}

            {createExpandableSection("Role and change password", <FaLock />, [
              { path: "/admin/create-new-role", text: "Create new role", code: "role.create_admin_user" },
              { path: "/admin/change-password", text: "Change password", code: "role.change_password" },
            ].filter(i => hasAccess(i.code)))}
          </>
        )}
        {userRole === "student" && (
          <>
            {createExpandableSection("Student", <PiStudentBold />, [
              { path: "/student/dashboards", text: "Dashboard" },
              { path: "/student/StudentProfileCard", text: "Student Profile" },

              {
                path: "/student/StudentAddressDetail",
                text: "Address Details",
              },
              {
                path: "/student/StudentChangePassword",
                text: "Change Password",
              },
              {
                path: "/student/about-us",
                text: "About Us",
              },

              { path: "/student/view-attendance", text: "View Attendance" },
              { path: "/student/view-result", text: "View Result" },
              { path: "/student/assignment", text: "Assignment" },

              { path: "/student/payment-gateway", text: "Payment" },
              { path: "/student/hostel-detail", text: "Hostel Details" },
              { path: "/student/online-class", text: "Online Class" },
              { path: "/student/mentor-details", text: "Mentor Details" },
              { path: "/student/time-table", text: "Time Table" },
              { path: "/student/circular", text: "Circular" },
              { path: "/student/grievance", text: "Grievance" },

              { path: "/student/library", text: "Library" },

              {
                path: "/student/previous-education",
                text: "Previous Education",
              },
              {
                path: "/student/submit-application",
                text: "RTGS Submit Application",
              },

            ])}
          </>
        )}
        {["staff", "teacher"].includes(userRole) && (
          <>
            {createExpandableSection("Staff", <GiTeacher />, [
              { path: "/staff/dashboard", text: "Dashboard" },
              { path: "/staff/dashboard-module", text: "Dashboard Module" },
              {
                path: "/staff/Attendance-update",
                text: "Attendance",
              },

              {
                path: "/staff/staff-time-table",
                text: "Time Table",
              },
              {
                path: "/staff/follow-up",
                text: "Follow Up",
              },
              { path: "/staff/staff-student-profile", text: "Student Details" },

              { path: "/staff/assignment-entry", text: "Assignment Entry" },
              { path: "/staff/document-upload", text: "Document Upload" },

              { path: "/staff/exam-result", text: "Exam Result" },
              { path: "/staff/lesson-plan", text: "Lesson Plan" },
              { path: "/staff/lesson-plan-list", text: "Lesson Plan Report" },
              { path: "/staff/change-password", text: "Change Password" },
            ])}
          </>
        )}
      </List>
    </Box>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={() =>
              setState((prevState) => ({ ...prevState, [anchor]: false }))
            }
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}

export default Sidebar;




